// extracted by mini-css-extract-plugin
export default {"control":"control_control__qHx92","button":"control_button__gXh3f"};